import { useAppSelector } from '../reducers';
import { productForSkuIdSelector, skuSelector, skuUuidForSkuIdSelector } from '../selectors/ProductsSelectors';
import { quantiyPackApiNameToQuantityNameMap } from '../v2/utils/quantiyPackApiNameToQuantityNameMap';
import { isQuantityPackDetails, isValidQuantityPackApiName } from '../v2/utils/typeguards';
import { usePurchaseOptionsCommonTerms } from './usePurchaseOptions';
export const useProductConfigurationsToPurchaseRequest = (productConfigurations, currencyCode, queryParamTerm) => {
  const productSkuUuids = useAppSelector(state => productConfigurations.map(({
    skuId
  }) => skuUuidForSkuIdSelector(state, {
    skuId
  })));
  const {
    commonTerms
  } = usePurchaseOptionsCommonTerms({
    productSkuUuids,
    queryParamTerm
  });
  const {
    products,
    quantityPacks
  } = useAppSelector(state => {
    const _products = [];
    const _quantityPacks = [];
    for (const {
      skuId,
      quantity
    } of productConfigurations) {
      const {
        apiName
      } = productForSkuIdSelector(state, {
        skuId
      });
      const sku = skuSelector(state, {
        skuId
      });
      if (isQuantityPackDetails(sku)) {
        const {
          quantityPackApiName,
          includedWithQuantityPack
        } = sku;
        if (!isValidQuantityPackApiName(quantityPackApiName)) {
          continue;
        }
        if (!includedWithQuantityPack) {
          continue;
        }
        _quantityPacks.push({
          quantityName: quantiyPackApiNameToQuantityNameMap[quantityPackApiName],
          totalQuantity: Math.floor(quantity / includedWithQuantityPack),
          parentProductApiName: apiName
        });
      } else {
        _products.push({
          productApiName: apiName,
          totalQuantity: quantity
        });
      }
    }
    return {
      products: _products,
      quantityPacks: _quantityPacks
    };
  });
  return {
    products,
    quantityPacks,
    commitmentTerm: commonTerms === null || commonTerms === void 0 ? void 0 : commonTerms.commitmentTerm,
    paymentTerm: commonTerms === null || commonTerms === void 0 ? void 0 : commonTerms.paymentTerm,
    currencyCode
  };
};